<template>
  <table-base
    has-phone-layout
    :columns="columns"
    :items="items"
    :pages="pages"
    :pagination="pagination"
    :is-loading="isLoading"
    has-custom-items-template
    :on-select-item="onSelectItem"
    :on-update-pagination="onUpdatePagination"
    :on-change-page="onChangePage"
  >
    <template v-slot:item-cell="scope" >
      <template v-if="scope.cell.column.isCurrency">
        {{
          displayColumnValue(scope.cell.item, scope.cell.column.value) +
          ' ' +
          scope.cell.item.cost_center?.currency?.symbol
        }}
      </template>

      <template v-else-if="scope.cell.column.value === 'created_at'">
        {{ $dayjs(scope.cell.item.created_at).format('MMM D, YYYY') }}
      </template>

      <template v-else-if="!scope.cell.column.isAction">
        {{ displayColumnValue(scope.cell.item, scope.cell.column.value) }}
      </template>

      <div
        v-else-if="scope.cell.item.has_pdf"
        class="trigger download-pdf"
        @click="(event) => {
          event.preventDefault();
          event.stopPropagation();
          onAction(scope.cell.item, scope.cell.column.action);
        }"
      >
          <v-icon>
          {{ scope.cell.column.icon }}
          </v-icon>
          {{ $t('download') }}
      </div>

      <span v-else class="no-pdf">&mdash;</span>
    </template>
  </table-base>
</template>

<script>
import columns from '../../config/invoices/columns';
import { extractNestedProp } from '@/utils';

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    pages: {
      type: Number,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    onSelectItem: {
      type: Function,
      required: true,
    },
    onUpdatePagination: {
      type: Function,
      required: true,
    },
    onChangePage: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns,
    }
  },
  methods: {
    displayColumnValue(item, value) {
      return extractNestedProp(item, value);
    },
    onAction({ id }, action) {
      if (action === 'pdf') {
        return this.$store.dispatch('invoices/downloadInvoice', { id }).catch((err) => err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
  @use '../../assets/styles/theme' as *;

  .no-pdf {
    color: rgba(var(--v-theme-on-surface), 0.4);
  }

  .trigger.download-pdf {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .v-icon {
      margin: 0 6px 0 0;
    }
  }

  .v-datatable {
    min-width: $table-min-width;
  }
</style>
